import React, { Component } from 'react';
import FullPageModal from 'app/common/react/components/growth/unauth/FullPageModal/FullPageModal';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { Box, Toast } from 'gestalt';

const styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    width: '380px',
    margin: 'auto',
    zIndex: '2000',
  },
  header: {
    padding: '20px',
    fontSize: '20px',
    fontWeight: 'bold',
    borderBottom: '1px solid #e7e7e7',
  },
  body: {
    color: '#333',
    fontSize: '14px',
    padding: '20px',
    lineHeight: '21px',
  },
  bottom: {
    background: '#f0f0f0',
    borderBottom: '1px solid #dadada',
    borderRadius: '0 0 6px 6px',
    height: '30px',
    padding: '10px 20px',
  },
  buttonContainer: {
    float: 'right',
  },
  continueButtonStyle: {
    backgroundColor: '#ab171e',
    border: '1px solid #820a0f',
    borderRadius: '3px',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    padding: '6px 12px',
  },
};

export class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  componentDidMount() {
    window.addEventListener('handleErrorMessage', this.handleErrorMessage);
  }

  componentWillUnmount() {
    clearTimeout(this.mobileToastTimeout);
  }

  onErrorClick = () => {
    const {
      userAgent: { isMobile, platform },
    } = this.context;
    const isMobileString = isMobile ? 'mobile' : 'non_mobile';
    trackRegisterAction(`unauth.error_modal.click.${platform}.${isMobileString}`);
  };

  handleOkayClick = () => {
    this.setState({ errorMessage: null, errorLink: null });
  };

  handleMobileToastTimeout = () => {
    this.setState({ errorMessage: null, errorLink: null });
  };

  handleErrorMessage = (evt) => {
    this.setState({ errorMessage: evt.detail.message, errorLink: evt.detail.href });
    this.mobileToastTimeout = setTimeout(this.handleMobileToastTimeout, 3000);
  };

  renderErrorModal = () => (
    <div style={styles.container}>
      <div style={styles.header}>{i18n._('Oops!')}</div>
      <div style={styles.body}>{this.state.errorMessage}</div>
      <div style={styles.bottom}>
        <div style={styles.buttonContainer}>
          <button
            className="UnauthBanner__continueButton"
            onClick={this.handleOkayClick}
            style={styles.continueButtonStyle}
          >
            {i18n._('Okay')}
          </button>
        </div>
      </div>
    </div>
  );

  render() {
    const {
      userAgent: { isMobile },
    } = this.context;
    const { errorLink, errorMessage } = this.state;

    if (errorMessage) {
      if (isMobile) {
        return (
          <Box bottom justifyContent="center" position="fixed" width="100%" display="flex">
            <a href={errorLink} onClick={this.onErrorClick}>
              <Toast color="red" icon="arrow-circle-forward" text={errorMessage} thumbnail />
            </a>
          </Box>
        );
      } else {
        return <FullPageModal renderContent={this.renderErrorModal} />;
      }
    } else {
      return null;
    }
  }
}

ErrorModal.contextTypes = {
  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ErrorModal;
